// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__GDfsA","messageBox":"LoadingOverlay_messageBox__ChWQZ"};